// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&family=Ubuntu:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Reset CSS Starts*/
* {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: none;
  border-radius: 0;
  outline: none;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.clear {
  font-size: 1%;
  height: 0;
  line-height: 0;
  width: 0;
  float: none;
  clear: both;
}

* html .clearfix {
  height: 1%;
}

input {
  outline: none;
}

ul {
  list-style: none;
}

li {
  list-style: none;
}

:focus {
  outline: 0;
}

img,
img a {
  border: 0;
  outline: 0;
}

a {
  text-decoration: none;
  outline: none;
  color: #3c88c4;
}

a:hover {
  text-decoration: none;
  outline: none;
}

img {
  border: none;
}

html {
  -webkit-text-size-adjust: 100%;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  margin: 0;
}

h1,
h2,
h3,
h4,
h5,
table,
table tr td,
table tr th {
  border: none;
}

textarea {
  resize: none;
  border: none;
  outline: none;
  background: none;
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
}

::placeholder,
::-webkit-input-placeholder {
  opacity: 1;
}

p {
  margin: 0;
}

figure {
  margin: 0;
}

ul {
  padding: 0;
  margin: 0;
}

.product-tablist::-webkit-scrollbar,
.deals-tablist::-webkit-scrollbar {
  display: none;
}

.accordion-button:focus {
  outline: none;
  box-shadow: none;
}

/*Reset CSS end*/
/* WebKit (Chrome, Safari) */
::-webkit-scrollbar {
  width: 4px; /* Set the width of the scrollbar */
}

::-webkit-scrollbar-thumb {
  background-color: #163B6B; /* Set the color of the thumb */
  border-radius: 6px; /* Set the border radius of the thumb */
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Set the color of the track */
}

/* Firefox */
/* Note: Firefox supports scrollbar styling without the need for vendor prefixes */
scrollbar {
  width: 12px; /* Set the width of the scrollbar */
}

scrollbar-thumb {
  background-color: #888; /* Set the color of the thumb */
  border-radius: 6px; /* Set the border radius of the thumb */
}

scrollbar-track {
  background-color: #f1f1f1; /* Set the color of the track */
}

html {
  font-size: 62.5%;
  font-weight: normal;
}

body {
  padding: 0;
  margin: 0;
  color: #163B6B;
  font-family: "Ubuntu", sans-serif;
  font-size: 16px !important;
  font-weight: 300;
  overflow-x: hidden;
  letter-spacing: 0.75px;
}

html,
body {
  height: 100%;
  width: 100%;
}

/*global css:start*/
.main-container {
  max-width: 100%;
  margin: 0 auto;
}

.container {
  max-width: 1320px;
  padding: 0 60px;
}

main {
  width: 100%;
  padding-top: 96px;
}

img {
  max-width: 100%;
}

/* Custom style */
.error-msg {
  font-size: 14px;
  padding-top: 5px;
}

.thank-you-message {
  font-size: 20px;
  text-align: center;
  padding-top: 16px;
}

/*custom-btn:start*/
.action-btn-wrap {
  display: block;
}

.custom-btn,
button.custom-btn {
  font-size: 16px;
  line-height: 145%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 46px;
  padding: 0 32px;
  border-radius: 8px;
}
.custom-btn.mLeft,
button.custom-btn.mLeft {
  margin-left: 24px;
}

/*custom-btn:end*/
/*custom-btn-primary:start*/
.custom-btn-primary,
button.custom-btn-primary {
  background-color: #2E9FC4;
  border: solid 1px #009AC6;
  color: #fff;
}
.custom-btn-primary:hover,
button.custom-btn-primary:hover {
  color: #2E9FC4;
  background-color: #fff;
}

.custom-btn-secondary,
button.custom-btn-secondary {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #163B6B;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

/*custom-btn-primary:end*/
h1 {
  background: linear-gradient(120deg, rgba(22, 59, 107, 0.83) 43.64%, rgba(0, 154, 198, 0.83) 90.8%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
  display: inline-block;
  font-weight: 300;
}

h2 {
  background: linear-gradient(120deg, rgba(22, 59, 107, 0.83) 43.64%, rgba(0, 154, 198, 0.83) 90.8%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 28px;
  display: inline-block;
  font-weight: 300;
  line-height: 168.75%;
}

h3 {
  font-size: 24px;
  line-height: 200%;
  font-weight: 300;
}

.form-control {
  background: #fff;
  color: #163B6B;
  border: solid 1px rgba(22, 59, 107, 0.2);
  border-radius: 8px;
  padding: 10px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  font-size: 14px;
  font-weight: 300;
  height: 44px;
}
.form-control:focus {
  box-shadow: none;
  background: #fff;
  color: #163B6B;
  border: solid 1px rgba(22, 59, 107, 0.2);
}

.form-control::placeholder {
  color: #163B6B;
}

.form-control:focus::placeholder {
  color: #163B6B;
}

textarea.form-control {
  height: 94px;
  white-space: unset;
}

.custom-card {
  border-radius: 32px;
  background: rgba(46, 159, 196, 0.1);
  padding: 40px;
}

.section-spacing {
  padding: 60px 0;
  border-top: solid 1px #2BABD0;
}

.section-desciption {
  font-size: 20px;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .container {
    padding: 0 40px;
  }
  .section-spacing {
    padding: 40px 0;
  }
  h1 {
    font-size: 36px;
  }
  h2 {
    font-size: 28px;
  }
  h3 {
    font-size: 22px;
  }
  .custom-card {
    padding: 24px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  body {
    font-size: 14px !important;
    font-size: 0.6px;
  }
  .container {
    padding: 0 16px;
  }
  .section-spacing {
    padding: 24px 0;
  }
  h1 {
    font-size: 28px;
    line-height: 140%;
  }
  h2 {
    font-size: 22px;
    line-height: 140%;
  }
  h3 {
    font-size: 18px;
  }
  .section-desciption {
    font-size: 14px;
  }
  .custom-card {
    border-radius: 16px;
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AACA,mBAAA;AACA;EAAI,SAAA;EAAW,UAAA;EAAY,6CAAA;EAA+C,YAAA;EAAwC,gBAAA;EAAkB,aAAA;EAAgB,0BAAA;EAAyF,sBAAA;AAY7O;;AAXA;EAAS,aAAA;EAAe,SAAA;EAAW,cAAA;EAAgB,QAAA;EAAU,WAAA;EAAa,WAAA;AAoB1E;;AAnBA;EAAmB,UAAA;AAuBnB;;AAtBA;EAAQ,aAAA;AA0BR;;AAzBA;EAAK,gBAAA;AA6BL;;AA5BA;EAAK,gBAAA;AAgCL;;AA/BA;EAAS,UAAA;AAmCT;;AAlCA;;EACQ,SAAA;EAAW,UAAA;AAuCnB;;AAtCA;EAAI,qBAAA;EAAuB,aAAA;EAAe,cAAA;AA4C1C;;AA3CA;EAAQ,qBAAA;EAAsB,aAAA;AAgD9B;;AA/CA;EAAM,YAAA;AAmDN;;AAlDA;EAAO,8BAAA;AAsDP;;AArDA;;;;;;EAKK,mBAAA;EAAqB,SAAA;AA0D1B;;AAzDA;;;;;;;;EAOc,YAAA;AA6Dd;;AA5DA;EAAW,YAAA;EAAc,YAAA;EAAc,aAAA;EAAe,gBAAA;AAmEtD;;AAlEA;EACI,gBAAA;AAqEJ;;AAlEA,gCAAA;AACA;;EAGE,gBAAA;EACA,SAAA;AAqEF;;AAlEA,YAAA;AACA;EAEE,qBAAA;AAqEF;;AAlEE;;EAEE,UAAA;AAqEJ;;AAlEE;EACE,SAAA;AAqEJ;;AAnEE;EACE,SAAA;AAsEJ;;AApEE;EACE,UAAA;EACA,SAAA;AAuEJ;;AArEE;;EAEE,aAAA;AAwEJ;;AAtEE;EACE,aAAA;EACA,gBAAA;AAyEJ;;AAvEA,gBAAA;AAEA,4BAAA;AACA;EACE,UAAA,EAAA,mCAAA;AAyEF;;AAtEA;EACE,yBAAA,EAAA,+BAAA;EACA,kBAAA,EAAA,uCAAA;AAyEF;;AAtEA;EACE,yBAAA,EAAA,+BAAA;AAyEF;;AAtEA,YAAA;AACA,kFAAA;AACA;EACE,WAAA,EAAA,mCAAA;AAyEF;;AAtEA;EACE,sBAAA,EAAA,+BAAA;EACA,kBAAA,EAAA,uCAAA;AAyEF;;AAtEA;EACE,yBAAA,EAAA,+BAAA;AAyEF;;AArEA;EAAO,gBAAA;EAAkB,mBAAA;AA0EzB;;AAzEA;EACE,UAAA;EACA,SAAA;EACA,cAAA;EACA,iCAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AA4EF;;AA1EA;;EACM,YAAA;EAAe,WAAA;AA+ErB;;AA7EA,mBAAA;AACA;EAAgB,eAAA;EAAiB,cAAA;AAkFjC;;AAjFA;EAAY,iBAAA;EAAmB,eAAA;AAsF/B;;AArFA;EAAM,WAAA;EAAa,iBAAA;AA0FnB;;AAzFA;EAAM,eAAA;AA6FN;;AA1FA,iBAAA;AAEA;EACE,eAAA;EACA,gBAAA;AA4FF;;AAzFA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AA4FF;;AAxFA,mBAAA;AACA;EACE,cAAA;AA2FF;;AAzFA;;EAEE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AA4FF;AA3FE;;EACE,iBAAA;AA8FJ;;AA3FA,iBAAA;AAEA,2BAAA;AACA;;EAEE,yBAAA;EACA,yBAAA;EACA,WAAA;AA6FF;AA5FE;;EACE,cAAA;EACA,sBAAA;AA+FJ;;AA3FA;;EAEE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AA8FF;;AA5FA,yBAAA;AAEA;EACE,kGAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AA8FF;;AA3FA;EACE,kGAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;AA8FF;;AA3FA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA8FF;;AA3FA;EACE,gBAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA8FF;AA5FE;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,wCAAA;AA8FN;;AA3FA;EACE,cAAA;AA8FF;;AA5FA;EACE,cAAA;AA+FF;;AA7FA;EACE,YAAA;EACA,kBAAA;AAgGF;;AA7FA;EACE,mBAAA;EACA,mCAAA;EACA,aAAA;AAgGF;;AA7FA;EACE,eAAA;EACA,6BAAA;AAgGF;;AA7FA;EACE,eAAA;AAgGF;;AA5FE;EACE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,aAAA;EA+FN;AACF;AA7FE;EACE;IACE,0BAAA;IACA,gBAAA;EA+FJ;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACE,eAAA;IACA,iBAAA;EA+FJ;EA7FE;IACI,eAAA;IACA,iBAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,eAAA;EA+FN;EA7FE;IACI,mBAAA;IACA,aAAA;EA+FN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&family=Ubuntu:wght@300;400;500;700&display=swap');\r\n/*Reset CSS Starts*/\r\n* { margin: 0; padding: 0; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); border: none; -webkit-border-radius: 0; border-radius: 0; outline: none;  -ms-box-sizing: border-box; -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;}\r\n.clear { font-size: 1%; height: 0; line-height: 0; width: 0; float: none; clear: both; }\r\n* html .clearfix { height: 1%; }\r\ninput { outline: none }\r\nul { list-style: none; }\r\nli { list-style: none }\r\n:focus { outline: 0; }\r\nimg,\r\nimg a { border: 0; outline: 0; }\r\na { text-decoration: none; outline: none; color: #3c88c4 }\r\na:hover{text-decoration: none;outline: none; }\r\nimg { border: none; }\r\nhtml { -webkit-text-size-adjust: 100%; }\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 { font-weight: normal; margin: 0; }\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\ntable,\r\ntable tr td,\r\ntable tr th { border: none }\r\ntextarea { resize: none; border: none; outline: none; background: none }\r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus, .btn-outline-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-outline-primary.dropdown-toggle:focus{\r\n    box-shadow: none;\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n  -moz-appearance: textfield;\r\n  appearance:textfield;\r\n}\r\n\r\n  ::placeholder,\r\n::-webkit-input-placeholder {\r\n    opacity: 1; \r\n  }  \r\n\r\n  p{\r\n    margin: 0;\r\n  }\r\n  figure{\r\n    margin: 0;\r\n  }\r\n  ul{\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n  .product-tablist::-webkit-scrollbar,\r\n  .deals-tablist::-webkit-scrollbar {\r\n    display: none; \r\n  }\r\n  .accordion-button:focus{\r\n    outline: none;\r\n    box-shadow: none;\r\n  }\r\n/*Reset CSS end*/\r\n\r\n/* WebKit (Chrome, Safari) */\r\n::-webkit-scrollbar {\r\n  width: 4px; /* Set the width of the scrollbar */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: #163B6B; /* Set the color of the thumb */\r\n  border-radius: 6px; /* Set the border radius of the thumb */\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background-color: #f1f1f1; /* Set the color of the track */\r\n}\r\n\r\n/* Firefox */\r\n/* Note: Firefox supports scrollbar styling without the need for vendor prefixes */\r\nscrollbar {\r\n  width: 12px; /* Set the width of the scrollbar */\r\n}\r\n\r\nscrollbar-thumb {\r\n  background-color: #888; /* Set the color of the thumb */\r\n  border-radius: 6px; /* Set the border radius of the thumb */\r\n}\r\n\r\nscrollbar-track {\r\n  background-color: #f1f1f1; /* Set the color of the track */\r\n}\r\n\r\n\r\nhtml { font-size: 62.5%; font-weight: normal;}\r\nbody { \r\n  padding: 0; \r\n  margin: 0; \r\n  color: #163B6B; \r\n  font-family: \"Ubuntu\", sans-serif; \r\n  font-size: 16px !important; \r\n  font-weight: 300; \r\n  overflow-x: hidden; \r\n  letter-spacing: 0.75px;\r\n}\r\nhtml,\r\nbody{ height: 100%;  width: 100%;}\r\n\r\n/*global css:start*/ \r\n.main-container{max-width: 100%; margin: 0 auto;}\r\n.container{ max-width: 1320px; padding: 0 60px;}\r\nmain{ width: 100%; padding-top: 96px;}\r\nimg { max-width: 100%;}\r\n\r\n\r\n/* Custom style */\r\n\r\n.error-msg{\r\n  font-size: 14px;\r\n  padding-top: 5px;\r\n}\r\n\r\n.thank-you-message{\r\n  font-size: 20px;\r\n  text-align: center;\r\n  padding-top: 16px;\r\n}\r\n\r\n\r\n/*custom-btn:start*/\r\n.action-btn-wrap{\r\n  display: block;\r\n}\r\n.custom-btn,\r\nbutton.custom-btn{\r\n  font-size: 16px;\r\n  line-height: 145%;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  white-space: nowrap; \r\n  height: 46px;\r\n  padding: 0 32px;\r\n  border-radius: 8px;\r\n  &.mLeft{\r\n    margin-left: 24px;\r\n  }\r\n}\r\n/*custom-btn:end*/\r\n\r\n/*custom-btn-primary:start*/\r\n.custom-btn-primary,\r\nbutton.custom-btn-primary{\r\n  background-color: #2E9FC4;\r\n  border: solid 1px #009AC6;\r\n  color: #fff;  \r\n  &:hover{\r\n    color: #2E9FC4;\r\n    background-color: #fff;\r\n  }\r\n}\r\n\r\n.custom-btn-secondary,\r\nbutton.custom-btn-secondary{\r\n  padding: 10px;\r\n  background-color: #fff;\r\n  border: 1px solid #163B6B;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n/*custom-btn-primary:end*/\r\n\r\nh1{\r\n  background: linear-gradient(120deg, rgba(22, 59, 107, 0.83) 43.64%, rgba(0, 154, 198, 0.83) 90.8%);\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  font-size: 40px;\r\n  display: inline-block;\r\n  font-weight: 300;\r\n}\r\n\r\nh2{\r\n  background: linear-gradient(120deg, rgba(22, 59, 107, 0.83) 43.64%, rgba(0, 154, 198, 0.83) 90.8%);\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  font-size: 28px;\r\n  display: inline-block;\r\n  font-weight: 300;\r\n  line-height: 168.75%;\r\n}\r\n\r\nh3{\r\n  font-size: 24px;\r\n  line-height: 200%;\r\n  font-weight: 300;\r\n}\r\n\r\n.form-control {\r\n  background: #fff;\r\n  color: #163B6B;\r\n  border: solid 1px rgba(22, 59, 107, 0.2);\r\n  border-radius: 8px;\r\n  padding: 10px 16px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  font-size: 14px;\r\n  font-weight: 300;\r\n  height: 44px;\r\n\r\n  &:focus{\r\n      box-shadow: none;\r\n      background: #fff;\r\n      color: #163B6B;\r\n      border: solid 1px rgba(22, 59, 107, 0.2);\r\n  }    \r\n}\r\n.form-control::placeholder {\r\n  color: #163B6B;\r\n}\r\n.form-control:focus::placeholder {\r\n  color: #163B6B;\r\n}\r\ntextarea.form-control{\r\n  height: 94px;\r\n  white-space: unset;\r\n}\r\n\r\n.custom-card{\r\n  border-radius: 32px;\r\n  background: rgba(46, 159, 196, 0.10);\r\n  padding: 40px;\r\n}\r\n\r\n.section-spacing{\r\n  padding: 60px 0;\r\n  border-top: solid 1px #2BABD0;\r\n}\r\n\r\n.section-desciption{\r\n  font-size: 20px;\r\n}\r\n  \r\n\r\n  @media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n    .container{\r\n        padding: 0 40px;\r\n    }\r\n    .section-spacing{\r\n        padding: 40px 0;\r\n    }\r\n    h1{\r\n        font-size: 36px;\r\n    }\r\n    h2{\r\n        font-size: 28px;\r\n    }\r\n    h3{\r\n        font-size: 22px;\r\n    }\r\n    .custom-card{\r\n        padding: 24px;\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    body{\r\n      font-size: 14px !important;\r\n      font-size: 0.6px;\r\n    }\r\n    .container {\r\n        padding: 0 16px;\r\n    }\r\n    .section-spacing{\r\n        padding: 24px 0;\r\n    }\r\n    h1{\r\n      font-size: 28px;\r\n      line-height: 140%;\r\n    }\r\n    h2{\r\n        font-size: 22px;\r\n        line-height: 140%;\r\n    }   \r\n    h3{\r\n        font-size: 18px;\r\n    } \r\n    .section-desciption{\r\n        font-size: 14px;\r\n    }  \r\n    .custom-card{\r\n        border-radius: 16px;\r\n        padding: 16px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
